import React, { useEffect, useRef } from 'react';
import { XIcon } from 'lucide-react';
interface ModalProps {
  title: string;
  message: string;
  onConfirm: () => void;
  onCancel: () => void;
}
export const Modal: React.FC<ModalProps> = ({
  title,
  message,
  onConfirm,
  onCancel
}) => {
  const modalRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        onCancel();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [onCancel]);
  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (modalRef.current && !modalRef.current.contains(e.target as Node)) {
        onCancel();
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, [onCancel]);
  return <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" data-id="element-77">
      <div ref={modalRef} className="bg-white dark:bg-gray-800 rounded-lg shadow-xl max-w-md w-full" role="dialog" aria-modal="true" aria-labelledby="modal-title" data-id="element-78">
        <div className="flex justify-between items-center p-4 border-b border-gray-200 dark:border-gray-700" data-id="element-79">
          <h3 id="modal-title" className="text-lg font-medium" data-id="element-80">
            {title}
          </h3>
          <button onClick={onCancel} className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300" aria-label="Close" data-id="element-81">
            <XIcon size={20} data-id="element-82" />
          </button>
        </div>
        <div className="p-4" data-id="element-83">
          <p className="text-gray-700 dark:text-gray-300" data-id="element-84">{message}</p>
        </div>
        <div className="flex justify-end gap-2 p-4 border-t border-gray-200 dark:border-gray-700" data-id="element-85">
          <button onClick={onCancel} className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md dark:bg-gray-700 dark:text-gray-200 dark:hover:bg-gray-600" data-id="element-86">
            Cancel
          </button>
          <button onClick={onConfirm} className="px-4 py-2 text-sm font-medium text-white bg-red-600 hover:bg-red-700 rounded-md" data-id="element-87">
            Confirm
          </button>
        </div>
      </div>
    </div>;
};